import { useEffect, useState } from "react";

import { isEventSeen } from "features/CenterContent/RoleContent/EventHandling/utils";

export const useEventSeenStatus = (uuid: string, version: number) => {
  const [hasBeenSeen, setHasBeenSeen] = useState(() =>
    isEventSeen(uuid, version),
  );

  useEffect(() => {
    setHasBeenSeen(isEventSeen(uuid, version));
  }, [uuid, version]);

  return { hasBeenSeen, setHasBeenSeen };
};
